/* define loading */

export const showLoading = function showLoading () {
    document.body.classList.add("sonphat-loading")
};

export const hideLoading = function hideLoading () {
    document.body.classList.remove("sonphat-loading")
};

export const showLoadingInit = function showLoading () {
    document.body.classList.add("loading-init")
};

export const hideLoadingInit = function hideLoading () {
    document.body.classList.remove("loading-init")
};

export default {
    show: showLoading,
    hide: hideLoading,
    hideLoadingInit: hideLoadingInit,
    showLoadingInit: showLoadingInit,
};